module.exports = __webpack_public_path__ + "../resources/img/storebadge_ko.ae62a642.png";